import { css, styled } from "styled-components";

export const StyledH4 = styled.p`
  color: black;
  font-family: Poppins;
  margin: 0;
`;

export const StyledServiceStepContainer = styled.div`
  display: grid;
  text-align: center;
  justify-content: space-evenly;
  background: var(--white);
  height: 70vh;
  place-items: center;
  grid-gap: 16px;
  max-height: 688px;
  min-height: 558px;
`;

export const StyledText = styled.p`
  color: var(--gray2);
  margin: 0;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 colonnes égales */
  gap: 20px 30px; /* Espacement entre les éléments */
  width: auto;
  height: auto;
  min-width: 576px;
  min-height: 358px;
  align-self: center;
  margin: 0 1rem;
  place-items: center;
`;

export const GridItem = styled.div`
  border: 1px solid #ccc;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  align-items: center;
  height: 18vh;
  min-height: 166px;
  width: 76%;
  &:hover {
    background: var(--catalina-blue);
    color: white;
  }
  ${(props) =>
    props.selected &&
    css`
      color: white;
      background: var(--catalina-blue);
    `}
`;

export const StyledServiceSVG = styled.img`
  width: 73px;
`;

export const CheckIconStyled = styled.img`
  position: absolute;
  top: 5px;
  right: 5px;
`;

export const StyledTextContainer = styled.div`
  height: 70px;
  padding-top: 20px;
`;
